import { storageKey } from '.';
import LocalStoragePreferences from '../../../../utils/local-storage-preferences';
import { SystemTypeEnum, FilterChip } from '../column-filter.types';

export function buildDateRanges(type: SystemTypeEnum, category: string) {
  const queryObject = Object.fromEntries(new URLSearchParams(window.location.search));
  let defaultDates: string[] = [];

  if (Object.keys(queryObject).length && Object.keys(queryObject).includes(category)) {
    defaultDates = queryObject[category].replace(/'/g, '').split(', ');
  } else {
    defaultDates = storedDateChips(type, category) ?? defaultDates;
  }

  return defaultDates;
}

function storedDateChips(type: SystemTypeEnum, category: string) {
  const storage = new LocalStoragePreferences();
  const chips: FilterChip[] = storage.getUserChips(`${type}-${storageKey}`);

  if (!chips || !chips.length) {
    return null;
  }

  const dateValue = chips.filter((chip) => (
    chip.key === category && chip.values[0]?.label === 'Custom'
  ))[0];

  if (!dateValue) {
    return null;
  }

  return dateValue.values[0].value.replace(/'/g, '').split(', ');
}

export default buildDateRanges;
